// extracted by mini-css-extract-plugin
export default {"layout":"layouts_layout__cP--K","content":"layouts_content__pX7D-"};